<template>
  <v-container fluid tag="section">
    <v-layout justify-center style="flex-wrap: wrap">
      <v-radio-group v-if="ifEnte" row justify-center v-model="filterEmitter" @change="loadTable()" :label="$t('emitter')">
        <v-radio :label="$t('ente')" value="ente"></v-radio>
        <v-radio :label="$t('club')" value="asd"></v-radio>
        <v-radio :label="$t('all_m_p')" value="all"></v-radio>
      </v-radio-group>

      <v-spacer></v-spacer>
      <v-radio-group row justify-center v-model="filterStatus" @change="loadTable()" :label="$t('status')">
        <v-radio :label="$t('all_m_p')" value="tutti"></v-radio>
        <v-radio :label="$t('active_m_p')" value="attivi"></v-radio>
        <v-radio :label="$t('waiting_approval')" value="attesa"></v-radio>
      </v-radio-group>
      <my-datepicker v-if="filterStatus === 'attivi'" v-model="validityDate" @input="loadTable" :label="$t('valid_at')"
        required="true" />
      <v-spacer></v-spacer>

      <div style="margin-top:10px">
        <v-btn class="ms-2" small @click="extractCsv('snapshot')" color="primary">{{
          $t("extract_csv_affiliated") }}</v-btn>
        <v-btn v-if="ifEnte" class="ms-2" small @click="extractCsv('users')" color="primary">{{ $t("extract_csv_users") }}</v-btn>
        <v-btn class="ms-2" small @click="extractCsv('coni')" color="primary">{{ $t("file_coni") }}</v-btn>
      </div>
    </v-layout>

    <v-row>
      <v-col cols="12">
        <DataTables @importMasterUser="importMasterUser" :headers="headers" :tableData="tableData"></DataTables>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

import Swal from "sweetalert2";
let _ = this;
export default {
  name: "list-tesserati",
  components: {
    DataTables,
    MyDatepicker,
  },
  data() {
    return {
      filterStatus: "attivi",
      filterEmitter: "ente",
      validityDate: new Date(),
      headers: [
        { text: this.$t("avatar"), value: "avatarUrl", type: "image" },
        { text: this.$t("surname"), value: "surname" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("fiscal_code"), value: "cFiscale" },
        { text: this.$t("birth_date"), value: "birthDate", type: "date" },
        { text: this.$t("eta"), value: "eta", type: "numeric" },
        { text: this.$t("affiliation_association"), value: "asd", type: "text" },
        {
          text: this.$t("affiliation_cards"),
          value: "tessere",
          type: "customCellComponent",
        },
        {
          text: this.$t("options"),
          value: "options",
          type: "buttons",
        },
      ],
      tableData: [],
    };
  },

  methods: {
    extractCsv(mode) {
      let params = { dateRef: this.validityDate };
      let link = "/auth/ente/getFileTesserati/" + mode + "/" + btoa(JSON.stringify(params));
      window.open(this.authorizeLink(link));
    },
    importMasterUser(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("import_in_portal"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "POST",
            "/auth/portal/importMasterUser/" + item.masterId,
            { msg: "always", dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) _.loadTable();
          });
        }
      });
    },
    loadTable() {
      let _ = this;
      let filter = { type: _.filterStatus, emitter: _.filterEmitter, validityDate: _.validityDate };
      _.tableData = [];
      _.chiamataAxios("POST", "/auth/ente/listTesserati", {
        body: { filter: filter },
      }).then((response) => {
        _.tableData = response.data.map(function (item) {
          if (!item.isInternal)
            item.options = [
              {
                icon: "mdi-home-import-outline",
                color: "warning",
                text: _.$t("import_in_portal"),
                function: "importMasterUser",
              },
            ];
          return item;
        });
      });
    },
  },
  mounted() {
    this.loadTable();
  },
  computed: {
    ifEnte: function () {
      return window.systemData && window.systemData.ifEnte
        ? window.systemData.ifEnte
        : false;
    },
  },
};
</script>

